import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportsReceptionComponent } from './components/reports-reception/reports-reception.component';
import { ReportReviewComponent } from './components/report-review/report-review.component';
import { ReportsReviewComponent } from './components/reports-review/reports-review.component';
import { ReportsPaymentComponent } from './components/reports-payment/reports-payment.component';
import { ReportsFeedbackComponent } from './components/reports-feedback/reports-feedback.component';
import { AddEditConceptResponseComponent } from './components/report-review/add-edit-concept-response/add-edit-concept-response.component';
import { CreateReportComponent } from './components/create-report/create-report.component';
import { ListReportsPaymentsComponent } from './components/reports-payment/list-reports-payments/list-reports-payments.component';
import { GenerateLayoutPaymentsComponent } from './components/reports-payment/generate-layout-payments/generate-layout-payments.component';
import { AuthGuard } from '../shared/guards/auth.guard';

const routes: Routes = [
  {path: '', component: ReportsReceptionComponent},
  {path: 'create-report', component: CreateReportComponent,canActivate:[AuthGuard]},
  {path: 'reports-reception', component: ReportsReceptionComponent, canActivate:[AuthGuard],data:{role:'Administrador'}},
  {path: 'reports-review', component: ReportsReviewComponent, canActivate:[AuthGuard],data:{role:'Administrador'}},
  {path: 'report-review/:id', component: ReportReviewComponent ,canActivate:[AuthGuard],data:{role:'Administrador'}}, 
  {path: 'reports-payment', component: ReportsPaymentComponent ,canActivate:[AuthGuard]},
  {path: 'reports-feedback', component: ReportsFeedbackComponent ,canActivate:[AuthGuard]},
  {path: 'list-reports-payments', component: ListReportsPaymentsComponent ,canActivate:[AuthGuard],data:{role:'Administrador'}},
  {path: '**', redirectTo: 'reports-reception'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExpenseReportsRoutingModule { }
